<template src="./component.html"></template>

<script>
import Contact from "./contact";

export default {
  name: "Footer",
  components: {Contact}

}
</script>

<style src="./component.scss" scoped lang="scss"/>
